import { Button, cn, SubmitButton, toast } from "@bleu.builders/ui";
import { DownloadCloudIcon } from "lucide-react";
import React, { useState } from "react";
import useSWRMutation from "swr/mutation";

import {
  DialogTemplatedMessage,
  TemplateMessage,
} from "#/components/CreateEmailLink";
import { useUser } from "#/contexts/UserContext";
import { fetcher } from "#/lib/fetcher";
import { replaceParams, UserPagePath } from "#/lib/pagesHelper";
import { toSlug } from "#/lib/toSlug";

const downloadFile = async (url, fileName) => {
  const response = await fetch(url);
  const blob = await response.blob();
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  const filename =
    fileName || url.split("/").pop().split("?")[0] || "download.zip";
  try {
    link.download = decodeURIComponent(filename);
  } catch {
    link.download = filename;
  }
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
};

const ErrorMessage = () => {
  const { user } = useUser();
  return (
    <>
      Créditos insuficientes para baixar o kit da tese.{" "}
      <DialogTemplatedMessage
        template={TemplateMessage.CREDITS_PURCHASE}
        firstName={user.first_name}
        email={user.email}
      >
        <Button variant="link" className="p-0 m-0 text-white h-auto underline">
          Clique aqui
        </Button>
      </DialogTemplatedMessage>{" "}
      para falar com nosso time e adquirir mais créditos.
    </>
  );
};

export const DownloadNowButton = ({
  thesisId,
  thesisTitle,
  setIsOpen,
  className = "",
  label = "Baixar kit da tese",
  downloadLatestVersion = false,
}) => {
  const [submitting, setSubmitting] = useState(false);
  const { trigger } = useSWRMutation(
    replaceParams(UserPagePath.PURCHASE_THESIS, {
      thesis_id: thesisId,
    }) +
      "?purchase_lastest_version=" +
      downloadLatestVersion,
    fetcher,
  );

  const submit = async () => {
    setSubmitting(true);
    const data = await trigger({ formData: new FormData(), method: "POST" });
    if (data?.data?.thesis_kit) {
      try {
        await downloadFile(data.data.thesis_kit, toSlug(thesisTitle));
        toast({
          title: "Sucesso!",
          description: "O kit da tese foi baixado.",
        });
      } catch (e) {
        toast({
          title: "Erro!",
          description: <ErrorMessage />,
          variant: "destructive",
        });
      }
      setIsOpen(false);
      setSubmitting(false);
    } else {
      toast({
        title: "Erro!",
        description: <ErrorMessage />,
        variant: "destructive",
      });
      setSubmitting(false);
      setIsOpen(false);
    }
  };

  return (
    <SubmitButton
      className={cn("gap-2 bg-orange-500 hover:bg-orange-400 w-fit", className)}
      type="submit"
      isSubmitting={submitting}
      onClick={submit}
    >
      <DownloadCloudIcon />
      {label}
    </SubmitButton>
  );
};
